var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('sidebar',{attrs:{"mobile":_vm.mobile,"toggleSidebar":_vm.toggleSidebar}}),_vm._v(" "),_c('div',{staticClass:"main"},[(_vm.unauthorised)?_c('unauthorised'):_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6aedd6ea","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/RNPLDashboardFrame.vue
// module id = null
// module chunks = 